export { default } from './RewardList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Reward/RewardList/index.js